import script from "./defaultTemplate.vue?vue&type=script&setup=true&lang=js"
export * from "./defaultTemplate.vue?vue&type=script&setup=true&lang=js"

import "./defaultTemplate.vue?vue&type=style&index=0&id=28a0897a&scoped=true&lang=css"

import exportComponent from "/home/steffen/Projekte/clubadmin/frontend/homepage/gc-schoenbuch/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-28a0897a"]])

export default __exports__